import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForSpecialOfferSixty(context: EditionAwarenessContextType): boolean {
	const { isInCollection, product, billingSourceSystem, entitlementId, transactionAccountId } =
		context;

	return (
		product === 'jira' &&
		!isInCollection &&
		billingSourceSystem === 'CCP' &&
		Boolean(entitlementId) &&
		Boolean(transactionAccountId) &&
		fg('special_offer_60_days_jira_standard_kill_switch')
	);
}
